import { ColDef, GridOptions } from '@ag-grid-community/core'

import {
    CustomLoadingOverlay,
    CustomLoadingOverlayParams,
} from '@/components/Shared/aggrid-custom-overlays/custom-loading-overlay'
import {
    CustomNoRowsOverlay,
    CustomNoRowsOverlayParams,
} from '@/components/Shared/aggrid-custom-overlays/custom-no-rows-overlay'
import { customDateComparator, gridDateFormatter } from '@/utils/tableGridUtils'
import { DEFAULT_FLEX_CENTER } from './scenarioBuilder.constant'

export const defaultColDefs: ColDef = {
  sortable: true,
  resizable: true,
  filter: 'agTextColumnFilter',
  cellStyle: { textAlign: 'left' },
  flex: 1,
  floatingFilter: false,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  suppressMovable: true,
  filterParams: {
    filterOptions: ['equals', 'contains'],
    suppressAndOrCondition: true,
  },
}

export const dateColDefs: ColDef = {
  filter: 'agDateColumnFilter',
  valueFormatter: gridDateFormatter,
  filterParams: {
    comparator: customDateComparator,
    buttons: ['reset'],
  },
}

export const defaultDateColDefs: ColDef = {
  ...defaultColDefs,
  ...dateColDefs,
}

export const agGridContainerStyle = {
  height: '30vh',
  width: '100%',
  // '--ag-grid-size': '6px',
  // '--ag-font-size': '12px',
}

export const agGridContainerLongStyle = {
  height: '50vh',
  width: '100%',
  margin: 1,
}

export const defaultAgGridSidebarProps = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressColumnExpandAll: true,
      },
    },
    {
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
    },
  ],
  hiddenByDefault: false,
}

export const defaultSingleSelectionHeaderColumn: ColDef = {
  headerName: '',
  field: 'contextMenu',
  width: 50,
  sortable: false,
  // filter: false,
  // resizable: false,
  suppressHeaderMenuButton: true,
  suppressFiltersToolPanel: true,
  suppressAutoSize: true,
  floatingFilter: false,
  headerCheckboxSelection: false,
  flex: 0,
  cellStyle: {
    ...DEFAULT_FLEX_CENTER,
  },
}

export const defaultMultipleSelectionHeaderColumn = {
  ...defaultSingleSelectionHeaderColumn,
  checkboxSelection: true,
  headerCheckboxSelection: true,
}

export const defaultGridOptions: GridOptions = {
  sideBar: false,
  rowSelection: 'single' as const,
  reactiveCustomComponents: true,
  defaultColDef: defaultColDefs,
  suppressCellFocus: false,
  copyHeadersToClipboard: false,
  suppressCopyRowsToClipboard: false,
  enableCellTextSelection: false,
  stopEditingWhenCellsLoseFocus: true,
  suppressFocusAfterRefresh: true,
  // domLayout: 'autoHeight',

  // custom loading components for aggrid
  loadingOverlayComponent: CustomLoadingOverlay,
  loadingOverlayComponentParams: CustomLoadingOverlayParams,

  noRowsOverlayComponent: CustomNoRowsOverlay,
  noRowsOverlayComponentParams: CustomNoRowsOverlayParams,
}
